import React, { Component } from 'react';
import DesktopSharing from './DesktopSharing';
import {
  startDesktopSharing,
  stopDesktopSharing,
  getDesktopSharingStatus,
} from './DesktopSharing.actions.js';
import { showSnackbar } from '../../../../common/state/snackbar/Snackbar.actions';
import Constants from '../../../../common/constants/Constants';
import PermissionsCheck from '../../../../common/components/PermissionsCheck/PermissionsCheck';
import PermissionsEnum from '../../../../common/constants/PermissionsEnum';
import Store from '../../../../redux/Store';
import { connect } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';

class DesktopSharingContainer extends Component {
  constructor() {
    super();
    this.state = {
      activeSharingStep: -1,
      // sharingSteps: ['starting', 'started', 'active', 'cancelling', 'cancelled'],
      sharingSteps: [
        { label: 'Starting session', name: 'StartingSession' },
        { label: 'Waiting for consent', name: 'WaitingForConsent' },
        { label: 'Establish session', name: 'EstablishSession' },
        { label: 'Session active', name: 'SessionActive' },
        { label: 'Session terminated', name: 'SessionTerminated' },
        { label: 'Canceled by Instrument', name: 'SessionTerminatedByInstrument' },
      ],
      guid: '',
      sessionId: '',
      startIsEnabled: false,
      cancelIsEnabled: false,
    };
  }

  componentDidMount() {
    this._handlePushMessage(this.props.pushMessage);
    this._getDesktopSharingStatus();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.pushMessage !== this.props.pushMessage) {
      this._handlePushMessage(this.props.pushMessage);
    } else if (prevProps.instrument.SerialNumber != this.props.instrument.SerialNumber) {
      this._handlePushMessage(this.props.pushMessage);
      this._getDesktopSharingStatus();
    }
  }

  render() {
    return (
      <PermissionsCheck appliedToPage={true} permission={PermissionsEnum.VIEW_DESKTOP_SHARING}>
        <DesktopSharing
          startDesktopSharing={this._startDesktopSharing}
          stopDesktopSharing={this._stopDesktopSharing}
          activeSharingStep={this.state.activeSharingStep}
          sharingSteps={this.state.sharingSteps}
          sessionId={this.state.sessionId}
          startIsEnabled={this.state.startIsEnabled}
          cancelIsEnabled={this.state.cancelIsEnabled}
        />
      </PermissionsCheck>
    );
  }

  _getSharingStepIndex = (sharingStep) => {
    return this.state.sharingSteps.findIndex((el) => el.name === sharingStep);
  };

  _startDesktopSharing = () => {
    const { instrument } = this.props;
    const newGuid = uuidv4();
    const sessionId = Math.random().toString().slice(2, 10);

    this.setState({
      activeSharingStep: this._getSharingStepIndex('StartingSession'),
      guid: newGuid,
      sessionId: sessionId,
    });

    startDesktopSharing(instrument.SerialNumber, newGuid, sessionId)
      .then((res) => {
        this.setState({
          activeSharingStep: this._getSharingStepIndex('WaitingForConsent'),
          startIsEnabled: false,
          cancelIsEnabled: true,
        });
      })
      .catch((res) => {
        Store.dispatch(
          showSnackbar({
            type: Constants.SNACKBAR_MESSAGE_TYPES.ERROR,
            message: 'Desktop sharing could not be started.',
          })
        );

        this.setState({
          activeSharingStep: this._getSharingStepIndex(''),
          guid: '',
          sessionId: '',
          startIsEnabled: true,
          cancelIsEnabled: false,
        });
      });
  };

  _stopDesktopSharing = () => {
    const { instrument } = this.props;

    stopDesktopSharing(instrument.SerialNumber, this.state.guid)
      .then((res) => {
        this.setState({
          activeSharingStep: this._getSharingStepIndex('SessionTerminated'),
          startIsEnabled: true,
          cancelIsEnabled: true,
        });
      })
      .catch((res) => {
        Store.dispatch(
          showSnackbar({
            type: Constants.SNACKBAR_MESSAGE_TYPES.ERROR,
            message: 'Desktop sharing could not be stopped.',
          })
        );
      });
  };

  _getDesktopSharingStatus = () => {
    const instrument = this.props.instrument;

    getDesktopSharingStatus(instrument.SerialNumber)
      .then((res) => {
        if (res == undefined || res == null || res.body == undefined || res.body == null) {
          this.setState({
            activeSharingStep: -1,
            startIsEnabled: true,
            cancelIsEnabled: false,
          });
        } else if (
          res.body.FreeSessions != undefined &&
          res.body.FreeSessions <= 1 &&
          res.body.SessionStatus == null
        ) {
          this.setState({
            activeSharingStep: -1,
            startIsEnabled: false,
            cancelIsEnabled: false,
          });

          Store.dispatch(
            showSnackbar({
              type: Constants.SNACKBAR_MESSAGE_TYPES.WARNING,
              message:
                'No free sessions for desktop sharing available, please try again in 5 minutes.',
            })
          );
        } else if (res.body.FreeSessions >= 1 && res.body.SessionStatus == null) {
          this.setState({
            activeSharingStep: -1,
            startIsEnabled: true,
            cancelIsEnabled: false,
          });
        } else {
          var activeStepIndex = this._getSharingStepIndex(res.body.SessionStatus);
          this.setState({
            activeSharingStep: activeStepIndex,
            guid: res.body.CorrelationId,
            sessionId: res.body.VNCPassword,
            startIsEnabled:
              res.body.FreeSessions > 1 && (activeStepIndex < 0 || activeStepIndex > 3),
            cancelIsEnabled: activeStepIndex > -1,
          });
        }
      })
      .catch((res) => {
        Store.dispatch(
          showSnackbar({
            type: Constants.SNACKBAR_MESSAGE_TYPES.ERROR,
            message: 'Desktop sharing status could not be loaded.',
          })
        );
      });
  };

  _handlePushMessage = () => {
    const { pushMessage } = this.props;
    if (pushMessage) {
      if (pushMessage.type === 'desktop_sharing_url') {
        this.setState({
          activeSharingStep: this._getSharingStepIndex('SessionActive'),
          startIsEnabled: false,
          cancelIsEnabled: true,
        });
        var desktopSharingWindow = window.open(pushMessage.data);

        try {
          desktopSharingWindow.focus();
        } catch (e) {
          Store.dispatch(
            showSnackbar({
              type: Constants.SNACKBAR_MESSAGE_TYPES.ERROR,
              message:
                'Window blocked by browser. Add this site to your exception list and try again.',
            })
          );
        }
      } else if (pushMessage.type === 'desktop_sharing_closed') {
        this.setState({
          activeSharingStep: this._getSharingStepIndex('SessionTerminated'),
          startIsEnabled: true,
          cancelIsEnabled: true,
        });
      } else if (pushMessage.type === 'desktop_sharing_closed_by_instrument') {
        this.setState({
          activeSharingStep: this._getSharingStepIndex('SessionTerminatedByInstrument'),
          startIsEnabled: true,
          cancelIsEnabled: true,
        });

        Store.dispatch(
          showSnackbar({
            type: Constants.SNACKBAR_MESSAGE_TYPES.INFO,
            message: 'Desktop sharing was canceled on the instrument side.',
          })
        );
      } else if (pushMessage.type === 'desktop_sharing_accepted') {
        this.setState({
          activeSharingStep: this._getSharingStepIndex('EstablishSession'),
          startIsEnabled: false,
          cancelIsEnabled: true,
        });
      } else if (pushMessage.type == 'desktop_sharing_failed') {
        this.setState({
          activeSharingStep: this._getSharingStepIndex('SessionTerminated'),
          startIsEnabled: true,
          cancelIsEnabled: true,
        });

        Store.dispatch(
          showSnackbar({
            type: Constants.SNACKBAR_MESSAGE_TYPES.ERROR,
            message: pushMessage.data,
          })
        );
      }
    }
  };
}

const mapStateToProps = (state, props) => ({
  pushMessage:
    state.push.pushMessages != null
      ? state.push.pushMessages.find(
          (el) =>
            (el.type === 'desktop_sharing_url' &&
              el.instrumentSerialNumber === props.instrument.SerialNumber) ||
            (el.type === 'desktop_sharing_closed' &&
              el.instrumentSerialNumber === props.instrument.SerialNumber) ||
            (el.type === 'desktop_sharing_accepted' &&
              el.instrumentSerialNumber === props.instrument.SerialNumber) ||
            (el.type === 'desktop_sharing_closed_by_instrument' &&
              el.instrumentSerialNumber === props.instrument.SerialNumber)
        )
      : null,
});

export default connect(mapStateToProps, {})(DesktopSharingContainer);
